module.exports = __webpack_public_path__ + "img/Butterfly_00182.5288ca82.png";